module.exports = __webpack_public_path__ + "img/117.e2a739b3.jpg";